var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"40px 0 0px 0"},attrs:{"id":"pre-paid"}},[_c('div',{staticClass:"upper-content"},[_c('lines-card',{attrs:{"load":_vm.load,"error":_vm.error,"data":_vm.data.html}}),_c('additional-info-card',{attrs:{"load":_vm.load,"error":_vm.error,"data":_vm.data.additionalInfo}})],1),_c('line-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }